import React from 'react';
import styled from 'styled-components';
import { colors, media } from '../../utils/styles';

export const FormGroup = ({ onClear, label, ...props }) => {
  return (
    <Wrap>
      <Input {...props} />
      {!!props.value && !!onClear && (
        <ClearButton onClick={() => onClear(props.name)} type="button" tabIndex="-1">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.1793 10.4137C11.3833 10.6177 11.3833 10.9645 11.1752 11.1767C10.9671 11.3848 10.6162 11.3848 10.4121 11.1808L8.00051 8.76919L5.5848 11.1849C5.38893 11.3808 5.03392 11.3848 4.82173 11.1767C4.61362 10.9686 4.6177 10.6136 4.81765 10.4137L7.22928 8.00204L4.81765 5.58633C4.6177 5.39046 4.61362 5.03137 4.82173 4.82326C5.02984 4.61107 5.38893 4.61923 5.5848 4.81918L8.00051 7.23081L10.4121 4.81918C10.6162 4.61515 10.9671 4.61515 11.1752 4.82326C11.3874 5.03137 11.3833 5.3823 11.1793 5.58633L8.76766 8.00204L11.1793 10.4137Z"
            />
          </svg>
        </ClearButton>
      )}
      {!!label && <Label>{label}</Label>}
    </Wrap>
  );
};

const Label = styled.span`
  font-size: 14px;
  color: #000000;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: inline-block;
  height: 17px;
  margin: auto 0;
`;

const Wrap = styled.div`
  margin: 0 0 12px;
  position: relative;
`;

const ClearButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  right: 0;
  width: 16px;
  height: 16px;
  border: 0;
  background: none;
  padding: 0;
  svg {
    fill: rgba(0, 0, 0, 0.5);
    transition: 0.2s ease-out fill;
  }
  &:hover {
    svg {
      fill: ${({ theme }) => theme.primary};
    }
  }
`;

const Input = styled.input`
  width: 100%;
  padding-right: 28px;
  height: 40px;
  display: flex;
  outline: none !important;
  align-items: center;
  font-size: 14px;
  border: 0;
  border-bottom: 1px solid rgba(34, 34, 34, 0.2);
  color: #000000;
  transition: 0.2s ease-out border;
  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
  &:focus {
    border-color: ${({ theme }) => theme.primary};
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }
  ${media.phone} {
    font-size: 16px;
    height: 50px;
  }
`;
